import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NxModalRef } from '@aposin/ng-aquila/modal';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-cancel-draft-modal',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './cancel-draft-modal.component.html',
  styleUrl: './cancel-draft-modal.component.scss',
})
export class CancelDraftModalComponent {
  
  constructor(
    private dialogRef: NxModalRef<any>,
  ) 
  { }
  
  onclickOK() {
    this.dialogRef.close("OK");
  }
}
